import { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type OverlayContainerProps = {
  className?: string;
  children: ReactNode | ReactNode[];
};

export const OverlayContainer: FC<OverlayContainerProps> = ({ className, children }) => (
  <div
    className={twMerge(
      "flex h-full flex-col rounded-lg border border-black-tint-90 bg-white px-4 py-3",
      className,
    )}
  >
    {children}
  </div>
);
